import React, { useState } from 'react';
import styled from 'styled-components';
import BaseModalComponent, { StyledBaseModal } from './BaseModal.component';
import { useTranslation } from 'react-i18next';
import CalendarComponent from '../Calendar.component';
import TimeChooserComponent from '../TimeChooser.component';
import { useModalManager } from '../../hooks/ModalManager.hook';

export interface DatepickerModalProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  defaultDate: number;
  handleChange: Function;
  withTime?: boolean;
}

const StyledDatePickerContainer = styled.div<{
  withTime: boolean;
}>`
  display: grid;
  grid-template-columns: ${props => (props.withTime ? '1fr 2fr' : '1fr')};
  gap: 15px;
`;
const StyledDatePickerWrapper = styled.div`
  ${StyledBaseModal} {
    //width: 600px;
  }
`;

const DatepickerModalComponent = ({
  defaultDate,
  withTime = true,
  handleChange: _handleChange,
}: DatepickerModalProps) => {
  const [date, setDate] = useState(defaultDate);
  const { t } = useTranslation();
  const { closeModal } = useModalManager();

  const handleChange = (type: 'date' | 'time') => (_date: number) => {
    setDate(_date);
    _handleChange(_date);
    if ((type === 'time' && withTime) || (type === 'date' && !withTime)) {
      closeModal();
    }
  };

  return (
    <StyledDatePickerWrapper>
      <BaseModalComponent header={t('Choose date')}>
        <StyledDatePickerContainer withTime={withTime}>
          <CalendarComponent
            date={date}
            onChange={({ start }: any) => handleChange('date')(start)}
          />
          {withTime && (
            <TimeChooserComponent date={date} onChange={handleChange('time')} />
          )}
        </StyledDatePickerContainer>
      </BaseModalComponent>
    </StyledDatePickerWrapper>
  );
};

export default DatepickerModalComponent;
